import { render, staticRenderFns } from "./sql-editor.vue?vue&type=template&id=bca1601e"
import script from "./sql-editor.vue?vue&type=script&lang=js"
export * from "./sql-editor.vue?vue&type=script&lang=js"
import style0 from "./sql-editor.vue?vue&type=style&index=0&id=bca1601e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports